export default "__VITE_ASSET__DnMkxpkB__"